<template>
  <q-select
    v-model="value"
    :options="options"
    class="san-field san-field--select"
    rounded
    outlined
    :color="color"
    dropdown-icon="mono-chevron-down"
    no-error-icon
    emit-value
    map-options
    :stack-label="$attrs.dense"
    :error-message="errorMessage"
    :error="!!errorMessage"
  >
    <template
      v-for="(slot, slotName) in $slots"
      #[slotName]="scope"
      :key="slotName"
    >
      <slot
        :name="slotName"
        v-bind="scope || {}"
      />
    </template>
  </q-select>
</template>

<script setup>
import { computed, watch } from 'vue'
import { useField } from 'vee-validate'

defineOptions({ name: 'SanFieldSelect' })
const props = defineProps({
  initialValue: { type: [Object, String], required: true },
  name: { type: String, required: true },
  type: { type: String, default: 'text' },
  color: { type: String, default: 'primary-mid' },
  default: { type: String, default: null },
  options: { type: Array, required: true }
})

const name = computed(() => props.name)
const { value, errorMessage, resetField, meta: { initialValue, dirty }, setValue, errors, setErrors, validate, ...rest } = useField(name, null, {initialValue:props.initialValue}) // eslint-disable-line

watch(() => value.value, async val => {
  // console.log(val, initialValue)
  if (val === initialValue) {
  // if (val === '' || val === null) {
    resetField()
    // resetField({ value: initialValue, errors: [] })
    // setErrors([])
    // await validate()
    // console.log('Errors after reset:', errorMessage.value)
    // console.log('Dirty after reset:', dirty)
  }
})

</script>
